import React, { useCallback, useMemo } from 'react';
import cx from 'classnames';
import { H5 } from '../../../../Typography';
import Icon from '../../../Icon';
import { useAccordion } from '../../context';
import styles from '../../Accordion.module.scss';
const AccordionItem = ({ id = 'item', title, children, className, }) => {
    const { expanded, multiple, onToggleExpanded } = useAccordion();
    const isExpanded = useMemo(() => {
        if (multiple) {
            return expanded && Array.isArray(expanded)
                ? expanded.includes(id)
                : false;
        }
        return expanded === id;
    }, [expanded, id, multiple]);
    const handleOnClick = useCallback(() => {
        onToggleExpanded(id);
    }, [id]);
    return (React.createElement("div", { className: cx(styles.accordionItem, className, {
            [styles.expanded]: isExpanded,
        }), onClick: handleOnClick },
        React.createElement("div", { className: cx(styles.header, className), role: "button", tabIndex: 0 },
            React.createElement(H5, null, title),
            React.createElement(Icon, { name: "chevron-arrow-down", className: styles.icon })),
        React.createElement("div", { className: cx(styles.itemContent) }, children)));
};
export default AccordionItem;
